import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';

import type { TrackingSite } from './utils';
import { extractSiteGroupingProps } from './utils';

export const trackingCodeInstallerOpened = (site: TrackingSite, data = {}): void => {
  if (typeof site !== 'undefined') {
    const eventData = {
      ...data,
      ...extractSiteGroupingProps(site),
    };

    Segment.track('Tracking Code Installer Opened', eventData);
  }
};
